const { createMuiTheme } = require('@material-ui/core')

const theme = createMuiTheme()

export default theme
